import { isAuthenticated } from '@src/utilities/auth'
import type { NavigationGuard } from 'vue-router'
import userApi from '@src/api/user'

const roleBasedNavigationGuard: NavigationGuard = async (to, from, next) => {
  if (!isAuthenticated()) {
    next()
    return
  }

  try {
    const { data: rolesData = [] } = await userApi.cached.getRoles()

    const requiredRoles: string[] = to.matched
      .map((matchedRoute) => matchedRoute.meta.requiredRole)
      .filter((role): role is string => !!role)

    if (requiredRoles.every((requiredRole) => rolesData.includes(requiredRole))) {
      next()
    } else {
      next('/error/403')
    }
  } catch (error) {
    console.error('Failed to fetch roles:', error)
    next('/error/403')
  }
}

export default roleBasedNavigationGuard
